import { Pipe, PipeTransform } from "@angular/core"
import { percentage } from "./percentage"

@Pipe({ name: "percentageFloor" })
export class PercentageFloorPipe implements PipeTransform {
    transform(value: any, exp?: any) {
        return percentage(value, exp, Math.floor)
    }
}
